import { defineMessages } from 'react-intl';

export default defineMessages({
  light: {
    id: 'bitkit.navigation.accountMenu.theme-selector.light.option',
    defaultMessage: 'Light',
    description: 'Label for the theme switcher light option',
  },
  dark: {
    id: 'bitkit.navigation.accountMenu.theme-selector.dark.option',
    defaultMessage: 'Dark',
    description: 'Label for the theme switcher dark option',
  },
  matchBrowser: {
    id: 'bitkit.navigation.accountMenu.theme-selector.match-browser.option',
    defaultMessage: 'Match browser',
    description: 'Label for the theme switcher match browser option',
  },
  title: {
    id: 'bitkit.navigation.accountMenu.theme-selector.theme-button',
    defaultMessage: 'Theme',
    description:
      'Label for button in the account menu to switch to a different theme',
  },
  feedbackMessage: {
    id: 'bitkit.navigation.accountMenu.theme-selector.feedback-message',
    defaultMessage: 'Got feedback? {link}',
    description: 'Label for feedback survey',
  },
  feedbackMessageLink: {
    id: 'bitkit.navigation.accountMenu.theme-selector.feedback-message-link',
    defaultMessage: 'Let us know',
    description: 'Link to open theme selector feedback modal',
  },
});
